import { useReducer, useState, useLayoutEffect } from "react";
import { useAuth } from "../../Auth/AuthProvider";
import instance from "../../Interceptor/api_instance";
import CheckInTruckF15 from "../CheckIn/CheckInTruckF15";
import CheckInTrailerF15 from "../CheckIn/CheckInTrailerF15";
import CheckInPhotos from "../CheckIn/CheckInPhotos";
import CheckOutForm from "./CheckOutForm";
import { useTranslation } from "react-i18next";
import { transformCheckOutTrailer, transformCheckOutTruck } from "../CheckIn/transformData";
import { ActionResponse } from "../../Components/Modals/ActionResponses";
import CheckoutConfirm from "../../Components/Modals/CheckoutConfirm";

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_TRAILER_LIST":
      return {
        ...state,
        trailerList: action.payload,
      };
    case "SET_TRUCK_LIST":
      return {
        ...state,
        truckList: action.payload,
      };
    case "SET_VISITOR_LIST":
      return {
        ...state,
        visitorList: action.payload,
      };
    case "PAGE_NUM":
      return {
        ...state,
        pageNum: action.payload,
      };
    case "IS_CARRYING":
      return {
        ...state,
        isCarrying: action.payload,
      };
    case "IS_TRAILER_SCANNING":
      return {
        ...state,
        trailerCodeScanner: action.payload,
      };
    case "IS_TRUCK_SCANNING":
      return {
        ...state,
        truckCodeScanner: action.payload,
      };
    case "ERROR_MESSAGE":
      return {
        ...state,
        [action.key]: action.payload,
      };
    case "SET_TRAILER_DIMENSION":
      return {
        ...state,
        trailerDimension: action.payload,
      };
    case "STORE_CUSTOMERS":
      return {
        ...state,
        customerList: action.payload,
      };
    case "CONFIRM":
      return {
        ...state,
        confirm: action.payload,
      };
    case "SUBMIT_REQUEST":
      return {
        ...state,
        submitLoading: true,
      };
    case "SUBMIT_COMPLETE":
      return {
        ...state,
        submitLoading: false,
        message: action.message,
        status: action.status,
      };
    case "LOCK_TRUCK_INPUT":
      return {
        ...state,
        lockTruck: action.value,
        trailerErrorMessage: action.message,
      };
    case "IS_LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      break;
  }
};

const initialState = {
  truckList: [],
  trailerList: [],
  visitorList: [],
  customerList: [],
  pageNum: 1,
  dimensionOption: null,
  isCarrying: null,
  isLoading: false,
  lockTruck: false,
  confirm: false,
  truckCodeScanner: false,
  trailerCodeScanner: false,
  truckErrorMessage: null,
  trailerErrorMessage: null,
  submitLoading: false,
};

export const CheckOutVehicle = ({ onClose }) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  // Check if any previous data is stored in cache
  const cachedFormState = JSON.parse(localStorage.getItem("checkOutForm"));
  const cachedFormData = JSON.parse(localStorage.getItem("checkOutData"));
  const cachedTruckF15 = JSON.parse(localStorage.getItem("truckForm"));
  const cachedTrailerF15 = JSON.parse(localStorage.getItem("trailerForm"));

  const [formData, setFormData] = useState(cachedFormData || {});
  const [formState, dispatchForm] = useReducer(
    reducer,
    cachedFormState || initialState
  );
  const [capturedPhotos, setCapturedPhotos] = useState([]);
  const [pinNum, setPinNum] = useState("");

  const [f15TrailerBody, setF15TrailerBody] = useState(
    cachedTrailerF15 ||
      (() => {
        const defaultStructure = {
          notes: "",
        };

        const keys = [
          "chassis",
          "inOutDoors",
          "trailerFloor",
          "tires",
          "sideWalls",
          "frontWall",
          "ceiling",
          "pests",
          "garbage",
          "cleanliness",
          "filter",
          "humidity",
        ];

        const form = {
          trailer_inspection: {},
          seal_tests: {
            view_seal: null,
            verify_seal: null,
            tug_on_seal: null,
            twistTurn_seal: null,
          },
          anomalies: null,
        };

        // Assign default structure to keys with value/notes structure
        keys.forEach((key) => {
          form.trailer_inspection[key] = { ...defaultStructure };
        });

        form.trailer_inspection["sealCondition"] = "";
        form.trailer_inspection["refrigerator"] = "";

        return form;
      })
  );
  const [f15TruckBody, setF15TruckBody] = useState(
    cachedTruckF15 ||
      (() => {
        const defaultStructure = {
          notes: "",
        };

        const keys = [
          "chassis",
          "bumper",
          "engine",
          "tires",
          "cabFloor",
          "ceiling",
          "fuelTank",
          "compartments",
          "airTank",
          "driveShafts",
          "fifthWheel",
          "exhaust",
          "pests",
          "garbage",
          "cleanliness",
        ];

        const form = {
          truck_inspection: {},
          anomalies: null,
        };

        // Create the truckForm object with the same structure for all keys
        keys.forEach((key) => {
          form.truck_inspection[key] = { ...defaultStructure };
        });

        return form;
      })
  );

  const nextForm = () => {
    if (user.location.loc_country === "Mexico") {
      // Mexico
      // This handles the F15 navigation
      if (formState.isCarrying && formState.pageNum === 2) {
        dispatchForm({ type: "PAGE_NUM", payload: formState.pageNum + 1 });
      } else if (!formState.isCarrying && formState.pageNum === 2) {
        dispatchForm({ type: "PAGE_NUM", payload: formState.pageNum + 2 });
      } else {
        dispatchForm({ type: "PAGE_NUM", payload: formState.pageNum + 1 });
      }
    } else if (
      formData.trailerOption?.label &&
      formData.trailerOption?.label?.toLowerCase()?.startsWith("lsf")
    ) {
      if (formState.pageNum === 1) {
        dispatchForm({ type: "PAGE_NUM", payload: 3 });
      } else {
        dispatchForm({ type: "PAGE_NUM", payload: formState.pageNum + 1 });
      }
    } else {
      // Skips over the F15 forms
      dispatchForm({ type: "PAGE_NUM", payload: 4 });
    }
  };

  useLayoutEffect(() => {
    const el = document.scrollingElement || document.documentElement;
    // temporarily defeat smooth and anchoring effects
    document.documentElement.style.overflowAnchor = "none";
    el.style.scrollBehavior = "auto";

    el.scrollTo(0, 0);
    requestAnimationFrame(() => {
      el.scrollTo(0, 0);
      // restore
      document.documentElement.style.overflowAnchor = "";
      el.style.scrollBehavior = "";
    });
  }, [formState.pageNum]);

  const backForm = () => {
    if (user.location.loc_country === "Mexico") {
      // Mexico
      // This handles the F15 navigation
      if (!formState.isCarrying && formState.pageNum === 4) {
        dispatchForm({ type: "PAGE_NUM", payload: formState.pageNum - 2 });
      } else {
        dispatchForm({ type: "PAGE_NUM", payload: formState.pageNum - 1 });
      }
    } else if (
      formData.trailerOption?.label &&
      formData.trailerOption?.label?.toLowerCase()?.startsWith("lsf")
    ) {
      if (formState.pageNum === 4) {
        dispatchForm({ type: "PAGE_NUM", payload: 3 });
      } else {
        dispatchForm({ type: "PAGE_NUM", payload: 1 });
      }
    } else {
      dispatchForm({ type: "PAGE_NUM", payload: 1 }); // Skips over the F15 forms
    }
  };

  const clearData = () => {
    localStorage.removeItem("checkOutForm");
    localStorage.removeItem("checkOutData");
    localStorage.removeItem("truckForm");
    localStorage.removeItem("trailerForm");
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (
        formData.truckCondition.toLowerCase() !== "good" &&
        formData.truckCondition.toLowerCase() !== "okay" &&
        formData.truckCondition.toLowerCase() !== "external-repair" &&
        formData.truckCondition.toLowerCase() !== "external repair" &&
        formData.truckCondition.toLowerCase() !== "ready"
      ) {
        throw new Error(t("forms.type.vehicle.warnings.truck_condition"));
      }
      dispatchForm({ type: "SUBMIT_REQUEST" });
      const data = new FormData();
      capturedPhotos.forEach((photo, index) => {
        data.append("photo", photo);
      });

      if (formState.isCarrying) {
        data.append(
          "data",
          JSON.stringify({
            ...transformCheckOutTrailer(formData),
            f15Trailer: { ...f15TrailerBody },
            f15Truck: { ...f15TruckBody },
            employee_pin: pinNum,
          })
        );
        if (
          formData.trailerCondition.toLowerCase() !== "good" &&
          formData.trailerCondition.toLowerCase() !== "okay" &&
          formData.trailerCondition.toLowerCase() !== "external-repair" &&
          formData.trailerCondition.toLowerCase() !== "external repair" &&
          formData.trailerCondition.toLowerCase() !== "ready"
        )
          throw new Error(t("forms.type.vehicle.warnings.trailer_condition"));
        const response = await instance.post(
          "assets/check-out-trailer/",
          data,
          { headers: { "Content-Type": "multipart/data-form" } }
        );
        if (response.status === 200) {
          dispatchForm({
            type: "SUBMIT_COMPLETE",
            message: t("forms.responses.success"),
            status: t("forms.type.success"),
          });
          clearData();
        }
      } else {
        data.append(
          "data",
          JSON.stringify({
            ...transformCheckOutTruck(formData),
            f15Truck: { ...f15TruckBody },
            employee_pin: pinNum,
          })
        );
        const response = await instance.post("assets/check-out-truck/", data, {
          headers: { "Content-Type": "multipart/data-form" },
        });
        if (response.status === 200) {
          dispatchForm({
            type: "SUBMIT_COMPLETE",
            message: t("forms.responses.success"),
            status: t("forms.type.success"),
          });
          clearData();
        }
      }
    } catch (err) {
      const error = err instanceof Error ? err.message : String(err);
      console.error(error);
      dispatchForm({
        type: "SUBMIT_COMPLETE",
        message: error,
        status: "Error",
      });
    }
  };
  return (
    <>
      {formState.pageNum === 1 && (
        <CheckOutForm
          formState={formState}
          setFormData={setFormData}
          dispatchForm={dispatchForm}
          formData={formData}
          close={onClose}
          nextForm={nextForm}
        />
      )}
      {formState.pageNum === 2 && (
        <CheckInTruckF15
          nextForm={nextForm}
          backForm={backForm}
          truckForm={f15TruckBody}
          setTruckForm={setF15TruckBody}
          inOrOut={false}
        />
      )}
      {formState.pageNum === 3 && (
        <CheckInTrailerF15
          backForm={backForm}
          nextForm={nextForm}
          trailerForm={f15TrailerBody}
          setTrailerForm={setF15TrailerBody}
          sealStatus={formData.sealNumber ? true : false}
          inOrOut={false}
        />
      )}
      {formState.pageNum === 4 && (
        <CheckInPhotos
          backForm={backForm}
          capturedPhotos={capturedPhotos}
          setCapturedPhotos={setCapturedPhotos}
          confirm={() => dispatchForm({ type: "CONFIRM", payload: true })}
          pinNum={pinNum}
          setPinNum={setPinNum}
          requestLoading={formState.requestLoading}
          inOrOut={false}
        />
      )}
      {formState.confirm && (
        <CheckoutConfirm
          type="check out"
          truck={formData.truckOption.label}
          trailer={formData.trailerOption?.label}
          close={() => dispatchForm({ type: "CONFIRM", payload: false })}
          submit={submit}
          requestLoading={formState.submitLoading}
        />
      )}
      {formState.message && (
        <ActionResponse
          message={formState.message}
          status={formState.status}
          close={
            formState.status === t("forms.type.success")
              ? () => onClose()
              : () =>
                  dispatchForm({
                    type: "SUBMIT_COMPLETE",
                    message: null,
                    status: null,
                  })
          }
        />
      )}
    </>
  );
};
